import React from 'react'
import { useEffect, useState, useRef } from 'react';
import { Modal, ModalHeader,Media,ModalBody,ModalFooter,Col,Button,Row ,Form,Input,InputGroupAddon,InputGroup,InputGroupText} from 'reactstrap';
import { Dialog } from 'primereact/dialog';



export const ModalPrice = (props) => {

    const {titlePrice,typeprice="viewPrices" ,handleprices,togglePrice,modalPrice,calcularPorcentajeDescuento,
    resul,handleInputChange,porcentaje,arrayExams,llavecard,totalCommercialLines,key,findRate} = props;
    console.log("🚀 ~ ModalPrice ~ findRate:", findRate)


  return (

    <Dialog
        header={titlePrice}
        visible={modalPrice}
        style={{ width: '400px' }}
        modal
        closable
        onHide={togglePrice}
        blockScroll  
        className="small-dialog"
        headerStyle={{
            backgroundColor: '#0d3b59',
            color: 'white',
            fontWeight: 'bold'
        }}
    >
        {
             typeprice ==="viewPrices" ?
             <ModalBody>
                <Col sm="12" key={llavecard}>
                    <Row>
                        <Col sm="3">
                        </Col>
                        <Col sm="6">
                            <label>Nuevo Precio:</label>
                            <br />

                            <InputGroup>
                                <InputGroupAddon addonType="append">
                                    <InputGroupText>$</InputGroupText>
                                </InputGroupAddon>

                                <Input
                                    className="form-control"
                                    name="porcentaje"
                                    value={porcentaje}
                                    type="text"
                                    inputMode="decimal"
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d+(\.\d*)?$/.test(value) || value === "") {
                                            handleInputChange(e);
                                        }
                                    }}
                                />
                            </InputGroup>
                        </Col>
                    </Row>
                </Col>
             </ModalBody>
             :""
       }  

        <div className="mt-3 text-right">
            <Button
                size="sm"
                className="btn-air-light"
                outline
                color="primary"
                onClick={() => {
                    calcularPorcentajeDescuento(arrayExams, porcentaje, findRate);
                    togglePrice(); 
                }}
            >
                Calcular
            </Button>
        </div>
    </Dialog>
    
  )
}
